import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class PlatformNotificationService extends BaseEntityService {
  public resource_url = `${this.BASE_SHARED_URL}/notification/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  retrieveLatestNotification(params={}) {
    let url = this.buildUrl(`${this.resource_url}latest`, '', params);
    return this.get(url);
  }
}
